module.exports = __webpack_public_path__ + "img/cnodejs_light.e2b40b75.svg";